import {
	IconActivity,
	IconActivityHeartbeat,
	IconAdjustmentsCog,
	IconAdjustmentsHorizontal,
	IconAlertCircle,
	IconAlertCircleFilled,
	IconAlertTriangle,
	IconAlertTriangleFilled,
	IconAlignCenter,
	IconAlignJustified,
	IconAlignLeft,
	IconAlignRight,
	IconArchive,
	IconArrowAutofitWidth,
	IconArrowBack,
	IconArrowBackUp,
	IconArrowBigDownLines,
	IconArrowBigUpLines,
	IconArrowDown,
	IconArrowForward,
	IconArrowLeft,
	IconArrowRight,
	IconArrowUp,
	IconArrowUpRight,
	IconArrowsDiagonal,
	IconArrowsDiagonalMinimize2,
	IconArrowsHorizontal,
	IconArrowsMaximize,
	IconArrowsMinimize,
	IconArrowsMoveVertical,
	IconArrowsRightLeft,
	IconArrowsSort,
	IconArrowsSplit2,
	IconArrowsUpDown,
	IconAt,
	IconBarcode,
	IconBell,
	IconBellOff,
	IconBinary,
	IconBlockquote,
	IconBold,
	IconBolt,
	IconBook,
	IconBook2,
	IconBookUpload,
	IconBookmark,
	IconBounceRight,
	IconBraces,
	IconBrain,
	IconBrandChrome,
	IconBrandSlack,
	IconBriefcase2,
	IconBuilding,
	IconBulb,
	IconBusinessplan,
	IconCalculator,
	IconCalendar,
	IconCalendarCancel,
	IconCalendarEvent,
	IconCalendarTime,
	IconChartArcs,
	IconChartBar,
	IconChartDonut,
	IconChartHistogram,
	IconChartLine,
	IconCheck,
	IconCheckbox,
	IconChecklist,
	IconChevronDown,
	IconChevronLeft,
	IconChevronRight,
	IconChevronUp,
	IconChevronsRight,
	IconCircle,
	IconCircleArrowUp,
	IconCircleCaretRight,
	IconCircleCheck,
	IconCircleCheckFilled,
	IconCircleChevronRight,
	IconCircleDashed,
	IconCircleFilled,
	IconCircleHalf2,
	IconCirclePlus,
	IconCircleX,
	IconCircleXFilled,
	IconClick,
	IconClipboard,
	IconClipboardCheck,
	IconClock,
	IconClockEdit,
	IconClockHour3,
	IconClockPlay,
	IconCloud,
	IconCode,
	IconCodeCircle2,
	IconCoin,
	IconColumnInsertLeft,
	IconColumnInsertRight,
	IconColumns,
	IconColumns2,
	IconCommand,
	IconCopy,
	IconCornerDownRightDouble,
	IconCornerLeftDown,
	IconCornerLeftUp,
	IconCreditCard,
	IconCrown,
	IconCsv,
	IconCursorText,
	IconCylinder,
	IconDatabase,
	IconDeviceDesktopAnalytics,
	IconDeviceLaptop,
	IconDiscount2Off,
	IconDiscountCheck,
	IconDiscountCheckFilled,
	IconDna,
	IconDoorEnter,
	IconDoorExit,
	IconDots,
	IconDotsVertical,
	IconDownload,
	IconEaseInControlPoint,
	IconEaseInOutControlPoints,
	IconEaseOutControlPoint,
	IconEdit,
	IconExclamationCircle,
	IconExclamationMark,
	IconExclamationMarkOff,
	IconExternalLink,
	IconEye,
	IconEyeOff,
	IconFile,
	IconFileAnalytics,
	IconFileCheck,
	IconFileDescription,
	IconFileExport,
	IconFileText,
	IconFileZip,
	IconFiles,
	IconFilterMinus,
	IconFlag,
	IconFlagDollar,
	IconFlame,
	IconFloatCenter,
	IconFloatLeft,
	IconFloatRight,
	IconFocusCentered,
	IconFolder,
	IconFolders,
	IconGhost2,
	IconGlobe,
	IconGraph,
	IconGripVertical,
	IconH1,
	IconH2,
	IconH3,
	IconH4,
	IconH5,
	IconH6,
	IconHandStop,
	IconHash,
	IconHeartbeat,
	IconHierarchy,
	IconHighlight,
	IconHistory,
	IconHome,
	IconHourglassEmpty,
	IconInbox,
	IconInfoCircle,
	IconItalic,
	IconJson,
	IconKey,
	IconLayersIntersect,
	IconLayersOff,
	IconLayersSubtract,
	IconLayout,
	IconLayoutDashboard,
	IconLayoutGrid,
	IconLayoutGridAdd,
	IconLayoutRows,
	IconLayoutSidebar,
	IconLayoutSidebarLeftCollapse,
	IconLayoutSidebarLeftExpand,
	IconLayoutSidebarRight,
	IconLayoutSidebarRightCollapse,
	IconLayoutSidebarRightExpand,
	IconLetterCase,
	IconLifebuoy,
	IconLineDashed,
	IconLink,
	IconList,
	IconListCheck,
	IconListDetails,
	IconListNumbers,
	IconListSearch,
	IconListTree,
	IconLoader,
	IconLoader2,
	IconLock,
	IconLockOpen,
	IconLogout,
	IconMail,
	IconMap,
	IconMapPin,
	IconMaximize,
	IconMenu2,
	IconMessage,
	IconMessageCircle2,
	IconMessageCircleQuestion,
	IconMessagePlus,
	IconMessages,
	IconMinus,
	IconMoodPlus,
	IconMoon,
	IconNewSection,
	IconNote,
	IconNotes,
	IconNotification,
	IconNumbers,
	IconPageBreak,
	IconPaint,
	IconPaperclip,
	IconPdf,
	IconPencil,
	IconPercentage,
	IconPhoto,
	IconPinned,
	IconPlayerPause,
	IconPlayerPlay,
	IconPlayerPlayFilled,
	IconPlayerSkipForward,
	IconPlayerStop,
	IconPlugConnected,
	IconPlus,
	IconPointFilled,
	IconPresentationAnalytics,
	IconProgressCheck,
	IconProgressDown,
	IconQuestionMark,
	IconQuote,
	IconRefresh,
	IconRegex,
	IconReload,
	IconRepeat,
	IconReplace,
	IconReportSearch,
	IconRestore,
	IconRibbonHealth,
	IconRosette,
	IconRotate2,
	IconRowInsertBottom,
	IconRowInsertTop,
	IconRulerMeasure,
	IconRun,
	IconSchema,
	IconSearch,
	IconSelect,
	IconSelector,
	IconSend,
	IconSeparatorHorizontal,
	IconServerBolt,
	IconSettings,
	IconShare2,
	IconShield,
	IconShieldCheck,
	IconShieldCheckFilled,
	IconShieldLock,
	IconShieldSearch,
	IconSortAZ,
	IconSortAscending,
	IconSortDescending,
	IconSortZA,
	IconSparkles,
	IconSpeakerphone,
	IconSql,
	IconSquareCheck,
	IconSquareRoundedCheck,
	IconStack2,
	IconStar,
	IconStarFilled,
	IconStrikethrough,
	IconSun,
	IconSwitchHorizontal,
	IconTable,
	IconTableColumn,
	IconTableRow,
	IconTag,
	IconTags,
	IconTagsOff,
	IconTargetArrow,
	IconTelescope,
	IconTemplate,
	IconTextWrap,
	IconThumbDown,
	IconThumbDownFilled,
	IconThumbUp,
	IconThumbUpFilled,
	IconTicket,
	IconTie,
	IconTimeline,
	IconToggleLeft,
	IconToggleRight,
	IconTool,
	IconTopologyStar,
	IconTrash,
	IconTrendingDown3,
	IconTrendingUp,
	IconTrendingUp3,
	IconUniverse,
	IconUnlink,
	IconUpload,
	IconUser,
	IconUserCheck,
	IconUserCircle,
	IconUserPlus,
	IconUserQuestion,
	IconUserShare,
	IconUsers,
	IconUsersGroup,
	IconViewportNarrow,
	IconViewportWide,
	IconWand,
	IconWorld,
	IconWreckingBall,
	IconWriting,
	IconX,
	IconZoomQuestion,
	IconZoomReplace,
} from '@tabler/icons-react';
import {
	BarChartIcon,
	ColumnChartIcon,
	CustomFilterIcon,
	DashboardIcon,
	InfoCircleFilledIcon,
	LineChartIcon,
	MessageFilledIcon,
	PriorityHighIcon,
	PriorityLowIcon,
	PriorityMediumIcon,
	PriorityNoneIcon,
	ScatterIcon,
	SmallXIcon,
	SparklesFilledIcon,
	StackedBarIcon,
	StackedColumnIcon,
} from './customIcons';
import ComposeIcon from './customIcons/ComposeIcon';
import {
	IconProgress0,
	IconProgress50,
	IconProgress75,
} from './customIcons/ProgressIcons';

export const TablerIconMap = {
	desktop: IconDeviceLaptop,
	slack: IconBrandSlack,
	briefcase: IconBriefcase2,
	workspace: IconBuilding,
	sidebar: IconLayoutSidebarLeftCollapse,
	PII: IconShieldCheckFilled,
	activity: IconActivity,
	activityHeartbeat: IconActivityHeartbeat,
	bounceRight: IconBounceRight,
	adjustmentsCog: IconAdjustmentsCog,
	adjustmentsHorizontal: IconAdjustmentsHorizontal,
	alertCircle: IconAlertCircle,
	alertCircleFilled: IconAlertCircleFilled,
	alertTriangle: IconAlertTriangle,
	alertTriangleFilled: IconAlertTriangleFilled,
	alignCenter: IconAlignCenter,
	alignJustified: IconAlignJustified,
	alignLeft: IconAlignLeft,
	alignRight: IconAlignRight,
	archive: IconArchive,
	arrowAutofitWidth: IconArrowAutofitWidth,
	arrowBack: IconArrowBack,
	arrowBackUp: IconArrowBackUp,
	arrowBigDownLines: IconArrowBigDownLines,
	arrowBigUpLines: IconArrowBigUpLines,
	arrowDown: IconArrowDown,
	arrowLeft: IconArrowLeft,
	arrowRight: IconArrowRight,
	arrowUp: IconArrowUp,
	arrowForward: IconArrowForward,
	arrowsUpDown: IconArrowsUpDown,
	arrowUpRight: IconArrowUpRight,
	arrowsDiagonal: IconArrowsDiagonal,
	arrowsDiagonalMinimize: IconArrowsDiagonalMinimize2,
	arrowsHorizontal: IconArrowsHorizontal,
	arrowsMinimize: IconArrowsMinimize,
	arrowsMaximize: IconArrowsMaximize,
	arrowsMoveVertical: IconArrowsMoveVertical,
	arrowsRightLeft: IconArrowsRightLeft,
	arrowsSort: IconArrowsSort,
	arrowsSplit: IconArrowsSplit2,
	at: IconAt,
	barCode: IconBarcode,
	bell: IconBell,
	bellOff: IconBellOff,
	binary: IconBinary,
	blockquote: IconBlockquote,
	bold: IconBold,
	bolt: IconBolt,
	book: IconBook,
	bookUpload: IconBookUpload,
	bookmark: IconBookmark,
	braces: IconBraces,
	brandChrome: IconBrandChrome,
	brandSlack: IconBrandSlack,
	building: IconBuilding,
	bulb: IconBulb,
	businessplan: IconBusinessplan,
	calculator: IconCalculator,
	calendar: IconCalendar,
	calendarCancel: IconCalendarCancel,
	calendarEvent: IconCalendarEvent,
	calendarTime: IconCalendarTime,
	chartArcs: IconChartArcs,
	chartBar: IconChartBar,
	chartHistogram: IconChartHistogram,
	chartLine: IconChartLine,
	check: IconCheck,
	checkbox: IconCheckbox,
	checklist: IconChecklist,
	chevronDown: IconChevronDown,
	chevronLeft: IconChevronLeft,
	chevronRight: IconChevronRight,
	chevronUp: IconChevronUp,
	chevronsRight: IconChevronsRight,
	circle: IconCircle,
	circleArrowUp: IconCircleArrowUp,
	circleCaretRight: IconCircleCaretRight,
	circleCheck: IconCircleCheck,
	circleCheckFilled: IconCircleCheckFilled,
	circleChevronRight: IconCircleChevronRight,
	circleDashed: IconCircleDashed,
	circleFilled: IconCircleFilled,
	circleHalf: IconCircleHalf2,
	circlePlus: IconCirclePlus,
	circleX: IconCircleX,
	circleXFilled: IconCircleXFilled,
	click: IconClick,
	clipboard: IconClipboard,
	clipboardCheck: IconClipboardCheck,
	clock: IconClock,
	clockEdit: IconClockEdit,
	clockHour3: IconClockHour3,
	clockPlay: IconClockPlay,
	cloud: IconCloud,
	code: IconCode,
	codeCircle2: IconCodeCircle2,
	coin: IconCoin,
	columnInsertLeft: IconColumnInsertLeft,
	columnInsertRight: IconColumnInsertRight,
	columns2: IconColumns2,
	columns: IconColumns,
	command: IconCommand,
	compose: ComposeIcon,
	copy: IconCopy,
	cornerDownRightDouble: IconCornerDownRightDouble,
	cornerLeftDown: IconCornerLeftDown,
	cornerLeftUp: IconCornerLeftUp,
	creditCard: IconCreditCard,
	crown: IconCrown,
	csv: IconCsv,
	cursorText: IconCursorText,
	cylinder: IconCylinder,
	database: IconDatabase,
	deviceDesktopAnalytics: IconDeviceDesktopAnalytics,
	discountCheck: IconDiscountCheck,
	discountCheckFilled: IconDiscountCheckFilled,
	dna: IconDna,
	documentation: IconBook2,
	doorEnter: IconDoorEnter,
	doorExit: IconDoorExit,
	dots: IconDots,
	dotsVertical: IconDotsVertical,
	download: IconDownload,
	customDashboard: DashboardIcon,
	edit: IconEdit,
	exclamationCircle: IconExclamationCircle,
	exclamationMark: IconExclamationMark,
	exclamationMarkOff: IconExclamationMarkOff,
	externalLink: IconExternalLink,
	eye: IconEye,
	eyeOff: IconEyeOff,
	file: IconFile,
	files: IconFiles,
	fileAnalytics: IconFileAnalytics,
	fileCheck: IconFileCheck,
	fileDescription: IconFileDescription,
	fileExport: IconFileExport,
	fileText: IconFileText,
	fileZip: IconFileZip,
	filter: CustomFilterIcon,
	filterMinus: IconFilterMinus,
	flag: IconFlag,
	flame: IconFlame,
	floatCenter: IconFloatCenter,
	floatLeft: IconFloatLeft,
	floatRight: IconFloatRight,
	focusCentered: IconFocusCentered,
	folder: IconFolder,
	folders: IconFolders,
	ghost: IconGhost2,
	globe: IconGlobe,
	graph: IconGraph,
	gripVertical: IconGripVertical,
	h1: IconH1,
	h2: IconH2,
	h3: IconH3,
	h4: IconH4,
	h5: IconH5,
	h6: IconH6,
	handStop: IconHandStop,
	hash: IconHash,
	heartbeat: IconHeartbeat,
	hierarchy: IconHierarchy,
	highlight: IconHighlight,
	history: IconHistory,
	home: IconHome,
	hourglassEmpty: IconHourglassEmpty,
	inbox: IconInbox,
	infoCircle: IconInfoCircle,
	infoCircleFilled: InfoCircleFilledIcon,
	italic: IconItalic,
	json: IconJson,
	key: IconKey,
	layersOff: IconLayersOff,
	layersIntersect: IconLayersIntersect,
	layersSubtract: IconLayersSubtract,
	layout: IconLayout,
	layoutDashboard: IconLayoutDashboard,
	layoutGrid: IconLayoutGrid,
	layoutGridAdd: IconLayoutGridAdd,
	layoutRows: IconLayoutRows,
	layoutSideBarLeftCollapse: IconLayoutSidebarLeftCollapse,
	layoutSidebar: IconLayoutSidebar,
	layoutSidebarRight: IconLayoutSidebarRight,
	layoutSidebarRightCollapse: IconLayoutSidebarRightCollapse,
	layoutSidebarRightExpand: IconLayoutSidebarRightExpand,
	letterCase: IconLetterCase,
	lifebuoy: IconLifebuoy,
	lineDashed: IconLineDashed,
	link: IconLink,
	list: IconList,
	listCheck: IconListCheck,
	listDetails: IconListDetails,
	listNumbers: IconListNumbers,
	listSearch: IconListSearch,
	listTree: IconListTree,
	loader: IconLoader,
	loader2: IconLoader2,
	lock: IconLock,
	lockOpen: IconLockOpen,
	logout: IconLogout,
	mail: IconMail,
	map: IconMap,
	mapPin: IconMapPin,
	maximize: IconMaximize,
	menu2: IconMenu2,
	message: IconMessage,
	messageCircle: IconMessageCircle2,
	messageCircleQuestion: IconMessageCircleQuestion,
	messageFilled: MessageFilledIcon,
	messagePlus: IconMessagePlus,
	messages: IconMessages,
	minus: IconMinus,
	moodPlus: IconMoodPlus,
	moon: IconMoon,
	newSection: IconNewSection,
	note: IconNote,
	notes: IconNotes,
	notPII: IconShield,
	notVerified: IconDiscount2Off,
	notification: IconNotification,
	numbers: IconNumbers,
	pageBreak: IconPageBreak,
	paint: IconPaint,
	paperclip: IconPaperclip,
	pdf: IconPdf,
	pencil: IconPencil,
	percentage: IconPercentage,
	photo: IconPhoto,
	pinned: IconPinned,
	playerPause: IconPlayerPause,
	playerPlay: IconPlayerPlay,
	playerPlayFilled: IconPlayerPlayFilled,
	playerSkipForward: IconPlayerSkipForward,
	playerStop: IconPlayerStop,
	plugConnected: IconPlugConnected,
	plus: IconPlus,
	pointFilled: IconPointFilled,
	presentationAnalytics: IconPresentationAnalytics,
	priorityHigh: PriorityHighIcon,
	priorityLow: PriorityLowIcon,
	priorityMedium: PriorityMediumIcon,
	priorityNone: PriorityNoneIcon,
	progress0: IconProgress0,
	progress50: IconProgress50,
	progress75: IconProgress75,
	progressCheck: IconProgressCheck,
	progressDown: IconProgressDown,
	questionMark: IconQuestionMark,
	quote: IconQuote,
	refresh: IconRefresh,
	regex: IconRegex,
	reload: IconReload,
	repeat: IconRepeat,
	replace: IconReplace,
	reportSearch: IconReportSearch,
	restore: IconRestore,
	ribbonHealth: IconRibbonHealth,
	rosette: IconRosette,
	rotate: IconRotate2,
	rowInsertBottom: IconRowInsertBottom,
	rowInsertTop: IconRowInsertTop,
	rulerMeasure: IconRulerMeasure,
	run: IconRun,
	schema: IconSchema,
	search: IconSearch,
	select: IconSelect,
	selector: IconSelector,
	send: IconSend,
	separatorHorizontal: IconSeparatorHorizontal,
	serverBolt: IconServerBolt,
	settings: IconSettings,
	share: IconShare2,
	shieldCheck: IconShieldCheck,
	shieldCheckFilled: IconShieldCheckFilled,
	shieldLockUnfilled: IconShieldLock,
	shieldSearch: IconShieldSearch,
	shield: IconShield,
	smallX: SmallXIcon,
	sortAZ: IconSortAZ,
	sortZA: IconSortZA,
	sparkles: IconSparkles,
	sparklesFilled: SparklesFilledIcon,
	speakerphone: IconSpeakerphone,
	sql: IconSql,
	squareCheck: IconSquareCheck,
	squareRoundedCheck: IconSquareRoundedCheck,
	sortAscending: IconSortAscending,
	sortDescending: IconSortDescending,
	stack: IconStack2,
	star: IconStar,
	starFilled: IconStarFilled,
	strikethrough: IconStrikethrough,
	sun: IconSun,
	switchHorizontal: IconSwitchHorizontal,
	table: IconTable,
	tableColumn: IconTableColumn,
	tableRow: IconTableRow,
	tag: IconTag,
	tags: IconTags,
	tagOff: IconTagsOff,
	targetArrow: IconTargetArrow,
	template: IconTemplate,
	textWrap: IconTextWrap,
	thumbDown: IconThumbDown,
	thumbDownFilled: IconThumbDownFilled,
	thumbUp: IconThumbUp,
	thumbUpFilled: IconThumbUpFilled,
	ticket: IconTicket,
	tie: IconTie,
	toggleRight: IconToggleRight,
	toggleLeft: IconToggleLeft,
	tool: IconTool,
	topologyStar: IconTopologyStar,
	trash: IconTrash,
	trendingUp: IconTrendingUp,
	trendingUp3: IconTrendingUp3,
	trendingDown3: IconTrendingDown3,
	unlink: IconUnlink,
	upload: IconUpload,
	user: IconUser,
	userCheck: IconUserCheck,
	userCircle: IconUserCircle,
	userPlus: IconUserPlus,
	users: IconUsers,
	userShare: IconUserShare,
	userQuestion: IconUserQuestion,
	telescope: IconTelescope,
	universe: IconUniverse,
	usersGroup: IconUsersGroup,
	verified: IconDiscountCheckFilled,
	verifiedUnfilled: IconDiscountCheck,
	viewportNarrow: IconViewportNarrow,
	viewportWide: IconViewportWide,
	wand: IconWand,
	world: IconWorld,
	wreckingBall: IconWreckingBall,
	writing: IconWriting,
	x: IconX,
	zoomQuestion: IconZoomQuestion,
	zoomReplace: IconZoomReplace,
	easeInControlPoint: IconEaseInControlPoint,
	easeOutControlPoint: IconEaseOutControlPoint,
	easeInOutControlPoints: IconEaseInOutControlPoints,
	flagDollar: IconFlagDollar,
	layoutSidebarLeftExpand: IconLayoutSidebarLeftExpand,
	brain: IconBrain,
	timeline: IconTimeline,
	barChart: BarChartIcon,
	columnChart: ColumnChartIcon,
	lineChart: LineChartIcon,
	stackBarChart: StackedBarIcon,
	stackColumnChart: StackedColumnIcon,
	scatterChart: ScatterIcon,
	chartDonut: IconChartDonut,
} as const;
